<lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

@if (vehiclesVM().isLoading && vehiclesVM().items.length === 0) {
  <lib-skeleton-item-two-columns></lib-skeleton-item-two-columns>
  <lib-spinner-loading></lib-spinner-loading>
} @else if (vehiclesVM().error && vehiclesVM().items.length === 0) {
  <div class="ion-text-center ion-padding">
    <p class="fs-sm">{{ 'vehicles.load_error' | translate }}</p>
    <ion-button
      size="small"
      (click)="onRetry()"
    >
      {{ 'general.retry' | translate }}
    </ion-button>
  </div>
} @else {
  <lib-infinite-scroll-header [infiniteScrollConfig]="headerConfig()"></lib-infinite-scroll-header>

  <ion-list class="ion-padding-top-0">
    @for (vehicle of vehiclesVM().items; track vehicle.id) {
      <lib-vehicle-item [vehicle]="vehicle"></lib-vehicle-item>
    } @empty {
      <lib-empty-result text="vehicles.no_vehicles"></lib-empty-result>
    }
  </ion-list>

  @if (!vehiclesVM().hasMore && vehiclesVM().items.length > 0 && !vehiclesVM().error) {
    <p class="fs-sm ion-text-center ion-padding">
      <strong>{{ 'general.no_more_data' | translate }}</strong>
    </p>
  }

  @if (vehiclesVM().isLoadingMore) {
    <lib-skeleton-item-two-columns></lib-skeleton-item-two-columns>
    <p class="fs-xs ion-text-center ion-padding">{{ 'general.loading_data' | translate }}</p>
  }

  @if (vehiclesVM().hasMore) {
    <ion-infinite-scroll
      position="bottom"
      threshold="136px"
      [disabled]="vehiclesVM().isLoading || vehiclesVM().isLoadingMore || vehiclesVM().isStale || !!vehiclesVM().error"
      (ionInfinite)="onIonInfinite($event)"
    >
      <ion-infinite-scroll-content [loadingText]="'general.loading_data' | translate"></ion-infinite-scroll-content>
    </ion-infinite-scroll>
  }
}
